export enum ShiftTeaching {
  DaytimePartial = 1,
  Nocturnal = 2,
  Integral = 3
}
